<template>
  <div id="Classroom">

    <Head />
    <div class="classroom">
      <div class="box1">
        <img src="../assets/Index/cr1.png" alt />
        <div class="box1_right">
          <img src="../assets/Index/top.png" alt />
          <div class="character">
            <p class="p1">
              <span>为</span>贯彻落实习近平总书记在企业家座谈会上的重要讲话精神，大力弘扬企业家精神、激发管理创新活力，助推煤炭工业高质量发展，中国煤炭工业协会决定以线上直播方式举办煤炭企业管理创新大讲坛。
            </p>
            <p class="p2">
              讲坛将搭建行业管理创新交流平台，解读经济管理政策，创新企业管理理论，讲述管理创新故事、分享管理创新智慧。届时将邀请国家政府有关部门、行业管理部门负责同志，大型煤炭企业集团负责同志，以及专家学者、管理创新成果主要创造人，围绕战略管理与商业模式、组织变革与集团管控、生产运营与安全管理、财务管理与金融服务、供应链与物流管理、数字智慧技术在管理创新中的应用等专题，挖掘优秀企业文化内涵和企业家精神特质及典型案例，推广分享行业企业高质量发展的创新成果。
            </p>
          </div>
          <img src="../assets/Index/bottom.png" alt />
        </div>
      </div>
      <!-- 7.6注释 煤炭企业管理大讲坛-->
      <p class="box2">煤炭企业管理大讲坛</p>
      <img class="box3" src="../assets/Index/cr2.png" alt />


      <!-- tags可滚动 -->

      <div id="click-scroll-X">
        <span class="left_btn" @click="leftSlide"> <i class="el-icon-arrow-left"></i></span>
        <div class="scroll_wrapper" ref="wrapperCon">
          <div class="scroll_list tag">
            <el-tag v-for="item in tags" :key="item.IssueName" :class="tag == item.IssueId ? 'active' : ''" effect="plain"
              @click="tagChange(item.IssueId)">
              {{ item.IssueName }}
            </el-tag>
          </div>
        </div>
        <div class="right_btn" @click="rightSlide"><i class="el-icon-arrow-right"></i></div>
      </div>


      <!-- <div class="tags-list" ref="totalLists">
        <div class="arrow-icon" @click="arrowBack" v-if="showButton">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="tag-style" ref="tagBox">
          <div class="scrollWrapper tag" ref="scrollWrapper" id="nav" :style="{ marginLeft: tabScroll }">
            <el-tag v-for="item in tags" :key="item.IssueName" :class="tag == item.IssueId ? 'active' : ''" effect="plain"
              @click="tagChange(item.IssueId)">
              {{ item.IssueName }}
            </el-tag>
          </div>
        </div>
        <div class="arrow-icon" @click="arrowForward" v-if="showButton">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div> -->

      <!-- <div class="tag">
      </div> -->
      <!-- 7.6注释 -->
      <div class="box4">
        <ul>
          <li v-for="(item, i) in pulpit" :key="i" @click="toDetails(item.ID)">
            <img :src="item.Image" alt />
            <p class="title" :title="item.Classname">
              {{ item.Classname | f }}
            </p>
            <p>演讲人：{{ item.Publisher }}</p>
            <p>累计播放：{{ item.Number }}次</p>
            <div>学习</div>
          </li>
        </ul>
      </div>
      <!-- 7.6注释 原因：图片丢失 -->
      <div class="Recommend">
        <div class="Title">
          推荐课程
          <span>煤炭、并购、企业金融等投行专业职能及课程案例</span>
        </div>
        <div class="rMain">
          <img :src="Img1" />
          <div class="recommend" v-for="(item, index) in Recommend" :key="index">
            <div class="curriculum" @click="toDetails(item.ID)">
              <div>
                <img :src="item.Image" />
              </div>
              <div>
                <div class="cName">{{ item.Classname }}</div>
                <div class="cDetails">
                  <div>
                    <div>
                      <img src="../assets/Classroom/0.png" />
                      {{ item.Number }}
                    </div>

                  </div>
                  <div class="btn">学习</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="Innovate">
        <div class="Title">
          创新课程
          <span>金融科技、人工智能、物联网、区块链等新兴时代创新科技呈现</span>
        </div>
        <div class="rMain">
          <img :src="Img2" />
          <div>
            <div class="recommend" v-for="(item, index) in Innovate" :key="index">
              <div class="curriculum" @click="toDetails(item.ID)">
                <div>
                  <img :src="item.Image" />
                </div>
                <div>
                  <div class="cName">{{ item.Classname }}</div>
                  <div class="cDetails">
                    <div>
                      <div>
                        <img src="../assets/Classroom/0.png" />
                        {{ item.Number }}
                      </div>

                    </div>
                    <div class="btn">学习</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../components/Head";
import Foot from "../components/Foot";
// import Curriculum from "../components/Curriculum";
import RightNav from "../components/RightNav";
export default {
  name: "Classroom",
  data() {
    return {
      tags: [
        // { label: "第一期", index: 1 },
        // { label: "第二期", index: 2 },
        // { label: "第三期", index: 3 },
        // { label: "第四期", index: 4 },
        // { label: "第五期", index: 5 },
        // { label: "第六期", index: 6 },
        // { label: "第七期", index: 7 },
        // { label: "第八期", index: 8 },
      ],
      tabScroll: "0px", // 移动的距离
      showButton: false, // 标签左右两侧箭头是否显示
      swiperScrollWidth: 0, // 盒子的宽度
      swiperScrollContentWidth: 0, // 内容的宽度
      navOffset: 0,
      timer: null,  // 定时器（方便清除
      tag: 1,
      Img1: '',
      Img2: '',
      isLogin: false,
      pulpit: [],
      pulpit2: [],
      pulpit3: [],
      pulpit4: [],
      pulpit5: [],
      Recommend: [],
      Innovate: [],
    };
  },
  filters: {
    f: function (val) {
      return val.length > 25 ? val.substring(0, 25) + "..." : val;
    },
  },
  mounted() {
    this.getTags()
    this.getRecommend(2);  //大讲坛
    this.getRecommend(1, 1);  //推荐课程
    this.getRecommend(1);  //创新课程
    this.getBanner()
  },
  methods: {
    getTags() {
      this.$axios
        .post(
          "classes/issues",
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.tags = res.data.data.list
          }
        });
    },
    getBanner() {
      let that = this
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: '6',
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.Img1 = res.data.data.list[0].imgurl
          }
        });
      this.$axios
        .post(
          "banner/info",
          that.$qs.stringify({
            banner_id: '7',
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            this.Img2 = res.data.data.list[0].imgurl
          }
        });
    },
    // 左箭头
    leftSlide() {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon.scrollLeft
      let num = 0
      clearInterval(this.timer)
      this.timer = null
      this.timer = setInterval(() => {
        //   !left:已经滚动到最左侧
        //   一次性滚动距离（可调节）
        if (!left || num >= 300) {
          // 停止滚动
          clearInterval(this.timer)
          this.timer = null
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left -= 30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30
      }, 20)
      // 20：速度（可调节）
    },
    // 右箭头
    rightSlide() {
      // 保存滚动盒子左侧已滚动的距离
      let left = this.$refs.wrapperCon.scrollLeft
      // 保存元素的整体宽度
      let scrollWidth = this.$refs.wrapperCon.scrollWidth
      // 保存元素的可见宽度
      let clientWidth = this.$refs.wrapperCon.clientWidth
      let num = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        // 已经滚动距离+可见宽度
        // left+clientWidth>=scrollWidth：滚动到最右侧
        // num>=300一次性滚动距离
        if (left + clientWidth >= scrollWidth || num >= 300) {
          clearInterval(this.timer)
          return
        }
        // 给滚动盒子元素赋值向左滚动距离
        this.$refs.wrapperCon.scrollLeft = left += 30
        // 保存向左滚动距离（方便判断一次性滚动多少距离）
        num += 30
      }, 20)
      // 20：速度（可调节）
    },
    tagChange(type) {
      this.tag = type
      this.getRecommend(2, '', type)
    },
    getRecommend(type, Recommend, Issue) {
      // type：1-课堂 2-讲坛
      // Recommend：0-不推荐 1-推荐
      this.$axios
        .post(
          "classes/index",
          this.$qs.stringify({
            Type: !Recommend ? type : "",
            Recommend: Recommend ? Recommend : "",
            Issue: Issue,
          })
        )
        .then((res) => {
          if (res.data.code == 10000) {
            if (!Recommend && type == 1) {
              this.Innovate = res.data.data.list;
            } else if (!Recommend && type != 1) {
              this.pulpit = res.data.data.list;
            } else {
              this.Recommend = res.data.data.list;
            }
          }
        });
    },
    // getInnovate() {
    //   this.$axios.post("classes/Recommend/Innovations").then((res) => {
    //     if (res.data.code == 10000) {
    //       console.log(res.data.data);
    //       this.Innovate = res.data.data.list;
    //     }
    //   });
    // },
    isLoginOpen(e) {
      console.log(2);
      this.isLogin = e;
    },
    toDetails(id) {
      // this.$axios
      //   .post(
      //     "classes/watchnums",
      //     this.$qs.stringify({
      //       ID: id,
      //       token: sessionStorage.getItem("token"),
      //     })
      //   )
      //   .then((res) => {
      //     console.log(res);
      //   });
      this.$router.push({
        path: "/CurriculumDetails",
        query: { id: id },
      });
    },
  },
  components: {
    Head,
    Foot,
    // Curriculum,
    RightNav
  },
};
</script>
<style lang="less" scoped>
#Classroom {
  width: 100%;
  min-width: 1000px;

  .classroom {
    width: 100%;
    padding: 0 1.35rem;
    margin-top: 3rem;
    padding-top: 0.34rem;

    .box4 {
      padding: 0.54rem 2.51rem 0rem 2rem;
      margin: 0 auto;

      ul {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        li {
          position: relative;
          margin-bottom: 0.57rem;
          cursor: pointer;

          p {
            padding: 0.11rem 0 0.1rem;
            color: #5d5d5d;
            font-size: 0.16rem;
          }

          .title {
            font-size: 0.2rem;
            color: #171717;
          }

          img {
            border-radius: 10px;
            width: 4.75rem;
            height: 2.23rem;
            cursor: pointer;
          }

          div {
            cursor: pointer;
            position: absolute;
            bottom: 2%;
            right: 0;
            background: #0556bc;
            color: #fff;
            width: 0.9rem;
            height: 0.29rem;
            text-align: center;
            line-height: 0.29rem;
            font-size: 0.16rem;
          }
        }
      }
    }

    .box3 {
      display: block;
      margin: 0.17rem auto 0;
      width: 8.74rem;
      height: 0.45rem;
    }

    .box2 {
      margin-top: 0.37rem;
      padding-left: 0.2rem;
      color: #0556bc;
      font-size: 28px;
      text-align: center;
    }

    .tag {
      // margin-top: .4rem;
      // padding-left: 2rem;

      .el-tag {
        margin-right: .2rem;
        cursor: pointer;
        height: .5rem;
        padding: 0 .3rem;
        line-height: .48rem;
        font-size: .2rem;

        &.active {
          background-color: #0556bc;
          border-color: #0556bc;
          color: #fff;
        }
      }
    }

    .box1 {
      display: flex;
      margin-top: 0.34rem;
      padding-left: 0.4rem;

      >img {
        width: 3.95rem;
        height: 3.93rem;
        margin-right: 0.64rem;
      }

      .box1_right {
        position: relative;

        color: #2e2e2e;

        .character {
          font-size: 0.16rem;

          p {
            line-height: 0.48rem;
            text-indent: 2em;
          }

          >.p1 {
            padding: 0.34rem 0.95rem 0 0.19rem;

            span {
              font-size: 0.26rem;
              color: #0556bc;
            }
          }

          >.p2 {
            padding: 0 0.95rem 0.14rem 0.19rem;
          }
        }

        img {
          width: 0.27rem;
          height: 0.34rem;
          position: absolute;
        }

        >img:last-child {
          bottom: 0;
          right: 6%;
        }
      }
    }

    .Title {
      display: flex;
      align-items: flex-end;
      font-size: 0.3rem;
      margin-bottom: 0.3rem;

      span {
        margin-left: 0.4rem;
        color: #a9a9a9;
        font-size: 0.16rem;
      }
    }

    .Recommend {
      width: 100%;

      .rMain {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;

        >img {
          width: 46.5%;
          margin-bottom: 0.3rem;
          display: block;
          height: 3rem;
          cursor: pointer;
        }
      }
    }

    .Innovate {
      width: 100%;

      .rMain {
        display: flex;
        justify-content: space-between;

        >img {
          width: 3.25rem;
          margin-bottom: 0.3rem;
          display: block;
          height: 6.3rem;
          flex-shrink: 0;
        }

        >div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          margin-left: 1.15rem;
        }
      }
    }

    .recommend {
      .curriculum {
        width: 3.25rem;
        margin-bottom: 0.3rem;
        border: 0.01rem solid #cbcbcb;
        border-radius: 0.1rem;
        cursor: pointer;

        >div:first-child {
          width: 100%;
          height: 2rem;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            display: block;
            border: 0.01rem solid #cbcbcb;
            border-top-left-radius: 0.1rem;
            border-top-right-radius: 0.1rem;
          }
        }

        >div:last-child {
          width: 100%;
          height: 1rem;
          line-height: 1.5;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 0.05rem 0.1rem 0.1rem;
          position: relative;

          .cName {
            font-size: 0.16rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .cDetails {
            margin-top: 0.1rem;
            display: flex;
            font-size: 0.12rem;
            align-items: center;
            display: flex;
            justify-content: space-between;
            align-items: center;

            >div {
              display: flex;

              div {
                display: flex;
                align-items: center;
                margin-right: 0.1rem;
                color: #868686;

                img {
                  width: 0.15rem;
                  height: 0.15rem;
                  margin-right: 0.05rem;
                }
              }
            }

            .btn {
              padding: 0.05rem 0.15rem;
              color: #ffffff;
              background: #0556bc;
            }
          }
        }
      }
    }
  }
}

#click-scroll-X {
  display: flex;
  align-items: center;
  margin-top: .4rem;

  .left_btn,
  .right_btn {
    font-size: 30px;
    cursor: pointer;
    margin: -15px 8px 0;
    color: #535353bb;
  }

  .scroll_wrapper {
    width: 1600px;
    overflow-x: scroll;
    padding-bottom: 10px;

    .scroll_list {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item {
        cursor: pointer;
        width: 146px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #ccc;
        border-radius: 3px;
        box-sizing: border-box;
        flex-shrink: 0;
        margin: 0 2px;
      }
    }
  }
}

/*隐藏滚动条*/
.scroll_wrapper::-webkit-scrollbar {
  display: none;
}
</style>